export default __webpack_public_path__ + "static/media/eox-api.5ed74d92.png";